export default "__VITE_ASSET__Qz1AYyDT__"